// extracted by mini-css-extract-plugin
export default {"section-header":"SectionHeader_section-header__PUWKY","section-header__span":"SectionHeader_section-header__span__1bFhE"};